import { render } from "./index.vue?vue&type=template&id=c5d2b3d8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=c5d2b3d8&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5d2b3d8"],['__file',"src/views/other/notice/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c5d2b3d8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c5d2b3d8', __exports__)) {
    console.log('reload')
    api.reload('c5d2b3d8', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=c5d2b3d8&scoped=true", () => {
    console.log('re-render')
    api.rerender('c5d2b3d8', render)
  })

}


export default __exports__